import { render, staticRenderFns } from "./QutaList.vue?vue&type=template&id=6fccd1ee&scoped=true&"
import script from "./QutaList.vue?vue&type=script&lang=js&"
export * from "./QutaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fccd1ee",
  null
  
)

export default component.exports